import axios from "./axiosInstance";

const AboutUsAPI = {
  getAboutUs: () => axios.get(`/aboutus`),
};

export default AboutUsAPI;